import CustomerSelectSingle from '@/components/customer/elements/Select.vue'
import CustomerSelectMulti from '@/components/customer/elements/SelectMulti.vue'
import FormSelectSingle from '@/components/form/elements/Select.vue'
import OrderSelectMulti from '@/components/order/elements/SelectMulti.vue'

import {
  SegmentField,
  ToggleField,
  DateField,
} from '@/components/fields'

export default {
  modelSelect: {
    Customer: {
      component: CustomerSelectSingle,
      reduce: item => item.idCustomer,
    },
    Form: {
      component: FormSelectSingle,
      reduce: item => item.idForm,
    },
  },
  modelBulkSelect: {
    Customer: {
      component: CustomerSelectMulti,
      default: [],
      reduce: items => items.map(item => item.idCustomer),
      validate: items => items.length,
    },
    Order: {
      component: OrderSelectMulti,
      default: [],
      reduce: items => items.map(item => item.idOrder),
      validate: items => items.length,
    },
  },
  select: {
    component: SegmentField,
    format: {
      default: 'csv',
    },
  },
  boolean: {
    component: ToggleField,
  },
  date: {
    component: DateField,
  },
}
